import { render, staticRenderFns } from "./TodoTaskHandlerSidebar.vue?vue&type=template&id=4ab7f9c1&scoped=true&"
import script from "./TodoTaskHandlerSidebar.vue?vue&type=script&lang=js&"
export * from "./TodoTaskHandlerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TodoTaskHandlerSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TodoTaskHandlerSidebar.vue?vue&type=style&index=1&id=4ab7f9c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab7f9c1",
  null
  
)

export default component.exports